export default __webpack_public_path__ + "static/goal2-e9b0738213a93034d82ed50e735cb270.png";